import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkIcon } from 'uitk-react-icons';
import { UitkLink, UitkLinkAlign, UitkLinkProps } from 'uitk-react-link';

import { DoubleLink } from 'components/common/media/double-link';

const LinkTracked = ClickTracker(DoubleLink);

export interface LinkMessage {
  icon?: {
    id: string;
  };
  link: {
    clientSideAnalytics?: {
      referrerId: string;
      linkName: string;
    };
    uri: {
      relativePath: string;
      value: string;
    };
    referrerId?: string;
    target?: string;
  };
  label?: string;
  value: string;
}

export interface LodgingLinkMessageProps extends UitkLinkProps {
  model: LinkMessage;
  useAbsolutePath: boolean;
}

export const LodgingLinkMessage: React.FunctionComponent<LodgingLinkMessageProps> = props => {
  const { iconPos, model, useAbsolutePath, children, ...rest } = props;

  if (!model) {
    return null;
  }

  const { icon, label, link, value } = model;

  const position = iconPos || UitkLinkAlign.LEFT;

  return (
    <UitkLink {...rest}>
      <LinkTracked
        to={useAbsolutePath ? link.uri.value : link.uri.relativePath}
        rfrr={link.clientSideAnalytics?.referrerId ?? link.referrerId}
        linkName={link.clientSideAnalytics?.linkName ?? label ?? value}
        target={link.target}
      >
        {icon && position === UitkLinkAlign.LEFT && <UitkIcon name={icon.id} />}
        {children || value}
        {icon && position === UitkLinkAlign.RIGHT && <UitkIcon name={icon.id} />}
      </LinkTracked>
    </UitkLink>
  );
};
LodgingLinkMessage.displayName = 'LodgingLinkMessage';
